import { Component, Input } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDividerModule } from '@angular/material/divider';
import { FieldBase } from '@nagel-types';
import { AutocompleteComponent } from '../fields/autocomplete/basicAutocomplete/autocomplete.component';
import { BaseFieldComponent } from '../fields/base-field/base-field.component';
import { CheckboxComponent } from '../fields/checkbox/checkbox.component';
import { ChipFormFieldComponent } from '../fields/chip-set/chip-set.component';
import { ConditionalSectionComponent } from '../fields/conditional-section/conditional-section.component';
import { DatePickerComponent } from '../fields/date-picker/date-picker.component';
import { DateRangePickerComponent } from '../fields/date-range-picker/date-range-picker.component';
import { FloatingActionButtonComponent } from '../fields/floating-action-button/floating-action-button.component';
import { InputFieldComponent } from '../fields/input-field/input-field.component';
import { InputWithSuffixFieldComponent } from '../fields/input-with-suffix-field/input-with-suffix-field.component';
import { LookupFieldComponent } from '../fields/lookup-field/lookup-field.component';
import { isNullOrUndefined } from '@nagel-utils';
import { IconComponent } from '@nagel-assests';

@Component({
    selector: 'lib-dynamic-form-field',
    imports: [
        ReactiveFormsModule,
        InputFieldComponent,
        InputWithSuffixFieldComponent,
        DatePickerComponent,
        DateRangePickerComponent,
        LookupFieldComponent,
        CheckboxComponent,
        FormsModule,
        FloatingActionButtonComponent,
        MatFormFieldModule,
        MatDividerModule,
        AutocompleteComponent,
        ConditionalSectionComponent,
        ChipFormFieldComponent,
        IconComponent
    ],
    templateUrl: './dynamic-form-field.component.html',
    styleUrl: './dynamic-form-field.component.scss'
})
export class DynamicFormFieldComponent extends BaseFieldComponent {
  //@ViewChild('dynamicComponentContainer', { read: ViewContainerRef, static: false }) dynamicComponentContainer!: ViewContainerRef;
  @Input() formControlName!: string;
  @Input() override form!: FormGroup;
  @Input() visible?: boolean = true;

  get isValid() {
      return this.form.controls[this.field.key].valid;
  }

  isHidden(field: FieldBase<unknown>) {
      return field.visible === false && !isNullOrUndefined(field.visible);
  }
}